import { ConfigProviderProps } from 'antd/lib/config-provider';
import deDE from 'antd/lib/locale/de_DE';
import enGB from 'antd/lib/locale/en_GB';
import enUS from 'antd/lib/locale/en_US';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import 'moment/locale/en-gb';
import 'moment/locale/de';

const LANG_TO_LOCALE = {
  en: enUS,
  'en-gb': enGB,
  'en-us': enUS,
  de: deDE,
  'de-de': deDE,
};

function getLocale(language: string) {
  let locale =
    LANG_TO_LOCALE[language as keyof typeof LANG_TO_LOCALE] ||
    LANG_TO_LOCALE[language.substr(0, 2) as keyof typeof LANG_TO_LOCALE];

  return locale || LANG_TO_LOCALE.en;
}

export function useI18n(language?: string) {
  const { i18n } = useTranslation();
  const lang = i18n.language.toLowerCase();

  React.useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [i18n, language]);

  React.useEffect(() => {
    moment.locale(lang);
  }, [lang]);

  const locale = React.useMemo(() => getLocale(lang), [lang]);

  const antdConfig: ConfigProviderProps = {
    locale,
  };

  return {
    antdConfig,
  };
}
